module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\n"